import { render } from "./FirstLogin.vue?vue&type=template&id=c1b24c4e&scoped=true&ts=true"
import script from "./FirstLogin.vue?vue&type=script&lang=ts"
export * from "./FirstLogin.vue?vue&type=script&lang=ts"

import "./FirstLogin.vue?vue&type=style&index=0&id=c1b24c4e&scoped=true&lang=css"
import "./FirstLogin.vue?vue&type=style&index=1&id=c1b24c4e&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b24c4e"]])

export default __exports__